import { Box, Flex, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { Button, WrappedImage } from '@time-line/components/common';
import { ProductBadge } from 'components/product/ProductBadge';
import { ProductReviewsStars } from 'components/reviews/ProductReviewsStars';
import { useSanityProduct } from 'hooks/product/useSanityProduct';
import { useShopifyProduct } from 'hooks/product/useShopifyProduct';
import NextLink from 'next/link';

interface ProductInArticleProps {
  slug: string;
}

export function ProductInArticle({ slug }: ProductInArticleProps) {
  const sanityProduct = useSanityProduct(slug, { required: true });
  const { data: shopifyProduct } = useShopifyProduct(slug);

  const { href, title, images, shortDescription, productBullet, isPreorder } =
    sanityProduct;

  return (
    <SimpleGrid
      borderTop="1px solid"
      borderColor="gray.600"
      pt="2xs"
      my="2xl"
      columns={{ base: 1, md: 2 }}
      spacing="sm"
    >
      {images && images[0] && (
        <WrappedImage
          alt={title}
          image={images[0]}
          ratio={4 / 5}
          sizes="(min-width: 786px) 25vw, 85vw"
          wrapperProps={{ width: '100%', gridColumn: 1, gridRow: 1 }}
        />
      )}
      <VStack spacing="sm" alignItems="start" justifyContent="space-between">
        <VStack alignItems="start" spacing="2xs" w="100%">
          <Flex w="100%" justifyContent="space-between" gap="4xs">
            <Text size="large2" as="h5">
              {title}
            </Text>
            {shopifyProduct && (
              <Text size="large2" as="span">
                <ProductBadge
                  availableForSale={shopifyProduct.availableForSale}
                  productBullet={productBullet}
                  isPreorder={isPreorder}
                />
              </Text>
            )}
          </Flex>
          <ProductReviewsStars
            productSlugs={[slug]}
            gridColumn="span 12"
            mt={{ lg: '4xs' }}
          />
          {shortDescription && (
            <Text
              gridColumn="span 12"
              noOfLines={4}
              size="body2"
              color="blackAlpha.700"
            >
              {shortDescription}
            </Text>
          )}
        </VStack>
        <Box w="100%">
          <Button
            as={NextLink}
            href={href}
            variant="outline"
            isWide
            sx={{
              textDecoration: 'none !important',
              width: '100%',
            }}
          >
            Buy now
          </Button>
        </Box>
      </VStack>
    </SimpleGrid>
  );
}
